import React, { useState } from "react";
import HandleInputChange from "../../../utils/HandleInputChange";
import AlertComponent from "../../../components/AlertComponent";
import ErrorAlert from "../../../components/ErrorAlert";
import TextAreaField from "../../../components/TextAreaField";
import updateOffer from "../api/updateOffer";

const OfferForm = ({ offer }) => {
  // variable
  const [formData, setFormData] = useState({
    offer_id: offer.id,
    content: offer.arabicDesc,
  });

  const [alert, setAlert] = useState("null");

  // Handler Send Update Offer
  const handlerUpdateOffer = async (e) => {
    e.preventDefault();
    let response = await updateOffer(formData);
    response ? setAlert("success") : setAlert("error");
    setTimeout(() => {
      setAlert("null");
    }, 5000);
  };

  return (
    <form className="w-full border-t py-10 ">
      {alert === "success" ? (
        <AlertComponent title="تم تعديل النص الترويجي بنجاح" content="" />
      ) : alert === "error" ? (
        <ErrorAlert title="حدث خطا ما" content="لم يتم إجراء التعديلات على النص الترويجي" />
      ) : (
        ""
      )}
      <TextAreaField
        name="content"
        label=""
        value={formData.content}
        onChange={(e) => {
          HandleInputChange(e, setFormData);
        }}
      />
      <button
        onClick={handlerUpdateOffer}
        className="rounded border-0 bg-indigo-500 px-6 py-2 text-lg text-white hover:bg-indigo-600 focus:outline-none"
      >
        حفظ التعديلات
      </button>
    </form>
  );
};

export default OfferForm;
